import classNames from 'classnames'
import React, { PropsWithChildren, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { isMobile } from 'react-device-detect'

type SelectionModalProps = {
  children: React.ReactNode
  isModal: boolean
}
export const SelectionModal = ({
  isModal,
  children,
}: PropsWithChildren<SelectionModalProps>) => {
  useEffect(() => {
    if (isModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  }, [isModal])

  useEffect(() => {
    return () => {
      document.body.style.overflow = ''
    }
  }, [])
  if (!isModal) return null

  return createPortal(
    <div className="md:h-screen h-full w-full fixed left-0 top-0 flex flex-col justify-center items-center bg-black bg-opacity-50 text-center z-[9999]">
      <div
        className={classNames('', {
          'overflow-auto max-h-[95vh] rounded-[20px] relative flex flex-col items-center  z-50 ':
            !isMobile,
          'overflow-auto w-full h-full ': isMobile,
        })}
      >
        {children}
      </div>
    </div>,
    document.body
  )
}
